<template>
  <div class="storeManage-list">
    <GlobalInfoBar
        title="广告管理"
        content="线上展示广告位及内容管理"
    />
    <GlobalChunkNo
        icon="search"
        title="筛选查询"
    >
      
      <div slot="filter">
        <storeManageFrom />
      </div>

      <storeManageTable />
    </GlobalChunkNo>
  </div>
</template>

<script>
import storeManageFrom from './From'
import storeManageTable from './Table'
export default {
  name: 'storeManage-list',
  components: {storeManageFrom,storeManageTable},
  data(){
    return{
      userName:"",
      userPhone:"",
      roleId:"",
    }
  },
  methods:{
    
  }
}
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.merchant-list{
}
</style>
